<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>Provide up-to-date feedback on the progress of a workflow or action with simple yet flexible progress bars.</p>
  <p>The easiest way to add the progressbar component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">progressbar</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
